import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { GLOBAL_VARIABIALES } from 'src/app/shared/constants/static-variable';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { ToastService } from 'src/app/shared/services/angular-service/toast.service';
import { CompanyService } from 'src/app/shared/services/node-api/company.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-customer-demand-report',
  templateUrl: './customer-demand-report.component.html',
  styleUrl: './customer-demand-report.component.scss'
})
export class CustomerDemandReportComponent {
  public customReport: UntypedFormGroup;
  public timelineOptions = Object.assign(GLOBAL_VARIABIALES.EXPECTED_TIMELINE);
  public budgetOptions = Object.assign(GLOBAL_VARIABIALES.BUDGET_RANGES);
  token: string;
  reportTypeOptions: any;
  industryOptions: any;

  constructor(
    private companyService: CompanyService,
    private toastService: ToastService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private router: Router,
    private localStorage: LocalStorageService,
    private _location: Location
  ) {
    this.customReport = new UntypedFormGroup({
      report_type: new UntypedFormControl('', [Validators.required]),
      industry: new UntypedFormControl('', [Validators.required]),
      requirement: new UntypedFormControl('',[Validators.minLength(5),Validators.maxLength(250),Validators.required]),
      timeline: new UntypedFormControl('', [Validators.required]),
      budget: new UntypedFormControl('', [Validators.required]),
      name : new UntypedFormControl('', [Validators.required]),
      contact: new UntypedFormControl('', [Validators.required]),
      email: new UntypedFormControl('',  [Validators.required, Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]),
      tc: new UntypedFormControl(false, Validators.requiredTrue),
    });

    this.industryOptions = JSON.parse(this.localStorage.getItem('custom_industry'));
    this.reportTypeOptions = JSON.parse(this.localStorage.getItem('report_type'));

    const email = this.localStorage.getItem('email');
    const name = this.localStorage.getItem('name');

    if (email) {
      this.customReport.get('email').setValue(email);
      this.customReport.get('email').disable();
    }

    if (name) {
      this.customReport.get('name').setValue(name);
      this.customReport.get('name').disable();
    }

  }

  ngOnInit(): void {
    this.recaptchaV3Service.execute('customerReportRequest').subscribe((token: string) => {
      this.token = token;
    });
  }

  submit() {
    this.companyService
      .customerReportData(this.customReport.getRawValue(), this.token)
      .then(
        (data: any) => {
          this.toastService.addSingle(
            'success','Successfully',
            'You have successfully send your requirement!'
          );
          this.customReport.reset();
          this.router.navigateByUrl('/reports');
        },
        (err) => {
          this.toastService.addSingle('error', 'Error', err.error.message);
        }
      );
  }
  goBack(event: MouseEvent) {
    event.preventDefault();  // Prevent the default anchor behavior
    this._location.back();
  }
}
